import { put, takeLatest, call, select } from 'redux-saga/effects'

import Api from '../../api'
import { addSettings } from 'portal-modules/common/redux/modules/settings'
import { RECEIVE_FEED_ITEMS } from 'portal-modules/community-feed/redux/modules/feed'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'
import { getClassifiedImageUrl } from 'portal-modules/classifieds/api/api'
// action types
const REQUEST_CLASSIFIEDS_WITH_SETTINGS =
  'rp/classifieds/REQUEST_CLASSIFIEDS_WITH_SETTINGS'
export const RECEIVE_CLASSIFIEDS_WITH_SETTINGS =
  'rp/classifieds/RECEIVE_CLASSIFIEDS_WITH_SETTINGS'
const REQUEST_MYADS = 'rp/classifieds/REQUEST_MYADS'
const RECEIVE_MYADS = 'rp/classifieds/RECEIVE_MYADS'
const DELETE_CLASSIFIED = 'rp/classifieds/DELETE_CLASSIFIED'
const CLASSIFIED_DELETED = 'rp/classifieds/CLASSIFIED_DELETED'
const SAVE_CLASSIFIED = 'rp/classifieds/SAVE_CLASSIFIED'
const CLASSIFIED_SAVED = 'rp/classifieds/CLASSIFIED_SAVED'
const REQUEST_MYFAVORITES = 'rp/classifieds/REQUEST_MYFAVORITES'
const RECEIVE_MYFAVORITES = 'rp/classifieds/RECEIVE_MYFAVORITES'
const REMOVE_FAVORITE = 'rp/classifieds/REMOVE_FAVORITE'
const FAVORITE_REMOVED = 'rp/classifieds/FAVORITE_REMOVED'
export const SET_CLASSIFIED_FAVORITE = 'rp/classifieds/SET_CLASSIFIED_FAVORITE'
export const SET_FAVORITE = 'rp/classifieds/SET_FAVORITE'
const SEND_MESSAGE = 'rp/messages/SEND_MESSAGE'
const SEND_MESSAGE_CLASSIFIED = 'rp/messages/SEND_MESSAGE_CLASSIFIED'
const SET_CLASSIFIED_FILTER_CATEGORIES =
  'rp/classifieds/SET_CLASSIFIED_FILTER_CATEGORIES'
const REQUEST_CLASSIFIEDS = 'rp/classifieds/REQUEST_CLASSIFIEDS'
export const SET_IMAGE_URLS = 'rp/classifieds/SET_IMAGE_URLS'
// action creators
export const requestClassifiedsWithSettings = () => ({
  type: REQUEST_CLASSIFIEDS_WITH_SETTINGS,
})

export const requestClassifieds = () => ({
  type: REQUEST_CLASSIFIEDS,
})

export const setClassifiedsWithFilterSettings = payload => ({
  type: SET_CLASSIFIED_FILTER_CATEGORIES,
  payload,
})

export const requestMyAds = () => ({
  type: REQUEST_MYADS,
})

export const deleteClassified = (payload, callback) => ({
  type: DELETE_CLASSIFIED,
  payload,
  callback,
})

export const saveClassified = createFormAction(SAVE_CLASSIFIED)

export const requestMyFavorites = () => ({
  type: REQUEST_MYFAVORITES,
})

export const removeFavorite = payload => ({
  type: REMOVE_FAVORITE,
  payload,
})

export const setFavorite = payload => ({
  type: SET_FAVORITE,
  payload,
})

export const setClassifiedfilterCategories = payload => ({
  payload,
})

export const setClassifiedsImageUrls = payload => ({
  type: SET_IMAGE_URLS,
  payload,
})

export const sendMessage = createFormAction(SEND_MESSAGE)

export const sendMessageClassified = createFormAction(SEND_MESSAGE)

export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_FEED_ITEMS:
      return payload?.classifieds && Object.keys(payload?.classifieds).length
        ? {
            ...state,
            ...payload.classifieds,
          }
        : state
    case RECEIVE_CLASSIFIEDS_WITH_SETTINGS:
      return { ...state, ...payload }
    case RECEIVE_MYADS:
      return { ...state, ...payload }
    case CLASSIFIED_DELETED:
      return Object.values(state).reduce((obj, classified) => {
        if (classified.id === payload) return obj
        return {
          ...obj,
          [classified.id]: classified,
        }
      }, {})
    case CLASSIFIED_SAVED:
      return {
        ...state,
        ...payload,
      }
    case RECEIVE_MYFAVORITES:
      return { ...state, ...payload }
    case FAVORITE_REMOVED:
      return {
        ...state,
        [payload]: {
          ...state[payload],
          is_favorite: false,
        },
      }
    case SET_CLASSIFIED_FAVORITE:
      return {
        ...state,
        [payload]: {
          ...state[payload],
          is_favorite: true,
        },
      }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// saga
function* fetchClassifiedsWithSettings() {
  const { classifieds, settings } = yield call(Api.getClassifiedsWithSettings)
  if (classifieds.length) {
    yield put({
      type: RECEIVE_CLASSIFIEDS_WITH_SETTINGS,
      payload: Object.values(classifieds).reduce((obj, classified) => {
        return {
          ...obj,
          [classified.id]: classified,
        }
      }, {}),
    })
  }
  if (Object.keys(settings).length) {
    yield put(addSettings({ classified: settings }))
  }
}

function* fetchClassifieds() {
  const { classifieds } = yield call(Api.getClassifieds)
  if (classifieds.length) {
    yield put({
      type: RECEIVE_CLASSIFIEDS_WITH_SETTINGS,
      payload: Object.values(classifieds).reduce((obj, classified) => {
        return {
          ...obj,
          [classified.id]: classified,
        }
      }, {}),
    })
  }
}

function* fetchClassifiedsWithFilterSettings(payload) {
  const { settings } = yield call(Api.getClassifiedsWithSettings)
  const newsettings = {
    ...settings,
    filteredCategories: payload.payload.filteredCategories,
  }

  yield put(addSettings({ classified: newsettings }))
}

function* fetchMyAds() {
  const { classifieds } = yield call(Api.getMyAds)
  if (classifieds.length) {
    yield put({
      type: RECEIVE_MYADS,
      payload: Object.values(classifieds).reduce((obj, classified) => {
        return {
          ...obj,
          [classified.id]: classified,
        }
      }, {}),
    })
  }
}

function* deleteMyClassified({ payload, callback }) {
  const { result } = yield call(Api.deleteClassified, { id: payload })

  if (result === true) {
    yield put({
      type: CLASSIFIED_DELETED,
      payload,
    })
    yield callback && typeof callback == 'function' && callback()
  }
}

// sagas
function* postSaveClassified({ payload, type, callback }) {
  
  const formData = new FormData()

  formData.append(
    'classified_request',
    JSON.stringify(payload.classified_request),
  )

  if (payload?.classified_images && Array.isArray(payload.classified_images)) {
    payload.classified_images.forEach(image => {
      if (image) {
        formData.append(`classified_images[]`, image)
      }
    })
  }

  const {classified} = yield call(Api.saveClassified, formData)
 
  if (classified && type === SAVE_CLASSIFIED) {
   
    if (classified && typeof classified === 'object' && Object.keys(classified).length) {
      yield put({
        type: CLASSIFIED_SAVED,
        payload: {
          [classified.id]: classified,
        },
      })
    }
  }

      
  const hasClassifiedKeys = classified && typeof classified === 'object' && Object.keys(classified).length > 0
  
  if (!hasClassifiedKeys || payload.id) {
    yield put(requestClassifieds())
  }
  
  typeof callback === 'function' && callback()
}

function* fetchMyFavorites() {
  const favoritesData = yield call(Api.getMyFavorites)
  yield put({
    type: RECEIVE_MYFAVORITES,
    payload: favoritesData,
  })
}

function* removeMyFavorite({ payload }) {
  const { result } = yield call(Api.removeFavorite, { id: +payload })
  if (result) {
    yield put({
      type: FAVORITE_REMOVED,
      payload,
    })
  }
}

function* setMyClassifiedFavorite({ payload }) {
  const { result } = yield call(Api.addFavorite, { id: +payload })
  if (result) {
    yield put({
      type: SET_CLASSIFIED_FAVORITE,
      payload,
    })
  }
}

function* postSendMessage({ payload }) {
  yield call(Api.sendMessage, payload)
}

function* watchSendMessage() {
  yield takeLatest(
    SEND_MESSAGE,
    createRequestSaga(postSendMessage, {
      key: 'classifieds',
      message: __('Messaging seller'),
      successMessage: __('Message sent successfully'),
      write: true,
    }),
  )
}

function* watchSendMessageClassified() {
  yield takeLatest(
    SEND_MESSAGE_CLASSIFIED,
    createRequestSaga(postSendMessage, {
      key: 'classifieds',
      message: __('Messaging seller'),
      successMessage: __('Message sent successfully'),
      write: true,
    }),
  )
}

function* watchRequestClassifiedsWithSettings() {
  yield takeLatest(
    REQUEST_CLASSIFIEDS_WITH_SETTINGS,
    createRequestSaga(fetchClassifiedsWithSettings, {
      key: 'classifieds',
      message: __('Finding classifieds'),
    }),
  )
}

function* watchRequestClassifieds() {
  yield takeLatest(
    REQUEST_CLASSIFIEDS,
    createRequestSaga(fetchClassifieds, {
      key: 'classifieds',
      message: __('Finding classifieds'),
    }),
  )
}

function* watchSetClassifiedsWithFilterSettings() {
  yield takeLatest(
    SET_CLASSIFIED_FILTER_CATEGORIES,
    createRequestSaga(fetchClassifiedsWithFilterSettings, {
      key: 'classifieds',
      message: __('Finding classifieds'),
    }),
  )
}

function* watchRequestMyAds() {
  yield takeLatest(
    REQUEST_MYADS,
    createRequestSaga(fetchMyAds, {
      key: 'classifieds',
      message: __('Finding your ads'),
    }),
  )
}

function* watchDeleteClassified() {
  yield takeLatest(
    DELETE_CLASSIFIED,
    createRequestSaga(deleteMyClassified, {
      key: 'classifieds',
      message: __('Deleting classified'),
      successMessage: __('Classified successfully deleted'),
      write: true,
    }),
  )
}

function* watchSaveClassified() {
  yield takeLatest(
    SAVE_CLASSIFIED,
    createRequestSaga(postSaveClassified, {
      key: 'classifieds',
      message: __('Posting classified ad'),
      successMessage: __('Ad successfully posted!'),
      write: true,
    }),
  )
}
function* watchRequestMyFavorites() {
  yield takeLatest(
    REQUEST_MYFAVORITES,
    createRequestSaga(fetchMyFavorites, {
      key: 'classifieds',
      message: __('Finding your favorites'),
    }),
  )
}

function* watchRemoveFavorite() {
  yield takeLatest(
    REMOVE_FAVORITE,
    createRequestSaga(removeMyFavorite, {
      key: 'classifieds',
      message: __('Removing favorite'),
      successMessage: __('Favorites updated'),
      write: true,
    }),
  )
}

function* watchSetFavorite() {
  yield takeLatest(
    SET_FAVORITE,
    createRequestSaga(setMyClassifiedFavorite, {
      key: 'classifieds',
      message: __('Syncing favorites'),
      write: true,
    }),
  )
}

function* setClassifiedImageUrls({ payload }) {
  function* fetchImageUrlRecursively(attachmentIds) {
    const classifiedImageUrls = yield select(
      ({ settings }) => settings?.classifiedImageUrls || {},
    )
    if (attachmentIds.length === 0) return

    const [currentAttachmentId, ...remainingAttachmentIds] = attachmentIds

    if (!classifiedImageUrls.hasOwnProperty(currentAttachmentId)) {
      const imageUrl = yield call(getClassifiedImageUrl, {
        id: currentAttachmentId,
      })

      yield put(
        addSettings({
          classifiedImageUrls: {
            ...classifiedImageUrls,
            [currentAttachmentId]: imageUrl,
          },
        }),
      )
    }
    yield call(fetchImageUrlRecursively, remainingAttachmentIds)
  }

  const attachmentIds = payload.reduce((acc, classified) => {
    const attachments =
      classified.classified_attachments || classified.attachments
    const ids = attachments.map(attachment => attachment.id)
    return [...acc, ...ids]
  }, [])

  yield call(fetchImageUrlRecursively, attachmentIds)
}

function* watchSetClassifiedImageUrls() {
  yield takeLatest(
    SET_IMAGE_URLS,
    createRequestSaga(setClassifiedImageUrls, {
      key: 'classifieds',
      message: __('Finding classifieds'),
      write: true,
    }),
  )
}

export const sagas = [
  watchRequestClassifiedsWithSettings,
  watchSetClassifiedsWithFilterSettings,
  watchRequestMyAds,
  watchDeleteClassified,
  watchSaveClassified,
  watchRequestMyFavorites,
  watchRemoveFavorite,
  watchSetFavorite,
  watchSendMessage,
  watchSendMessageClassified,
  watchRequestClassifieds,
  watchSetClassifiedImageUrls,
]
